export default "__VITE_ASSET__Dpc$XEUf__"